import { createContext } from 'react';
import { initialState } from '@Hooks/modalManager/mondal.consts.ts';
import type { InitialState } from '@Hooks/modalManager/modal.types.ts';

export const modalContext = createContext<{
  state: InitialState;
  setModal: (modalConfig: Partial<InitialState>) => void;
}>({
  state: initialState,
  setModal: () => {},
});
